<template>
  <div class="sky-page-report-view">
    <div class="page-function-toolbar">
      <el-button type="primary" @click="handleReturnSelection">确定</el-button>
      <el-button icon="el-icon-refresh" @click="refushTable"></el-button>
      <el-input
        placeholder="请输入编号/客户/客户岗位/数据包名/联系人模糊筛选"
        class="toolbar-input"
        size="medium"
        v-model="searchKeyword"
      >
        <span slot="suffix" class="el-input__suffix" @click="searchReq"
          ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
        </span>
      </el-input>

      <el-pagination
        class="toolbar-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handelPrev"
        @next-click="handelNext"
        :page-sizes="[5, 10, 20, 50, 100]"
        layout="total,sizes,prev,sp,next"
        :current-page="page"
        :page-size="pageSize"
        :total="pageTotal"
      >
      </el-pagination>
    </div>

    <el-table
      ref="table"
      :border="true"
      :data="specPositionList"
      :key="reportKey"
      :show-header="true"
      :column-drag-sortable="false"
      class="sky-host-dist"
      @select="selectEvent"
      @select-all="selectAllEvent"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="岗位名称" prop="positionName" width="185"> </el-table-column>
      <el-table-column label="岗位描述" prop="positionDesc" show-overflow-tooltip> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Drawer, Pagination, Input } from 'element-ui'

import { getSpecPositionList } from '@/api/spec'

export default {
  name: 'SkySpecPositionList',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Pagination.name]: Pagination,
    [Input.name]: Input
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      searchKeyword: null,
      shwoFunViewDetail: {},
      selectFuntion: [],
      pageTotal: 0,
      pageSize: 20,
      specPositionList: [],
      selectRowTempList: [],
      tableAllSelectIdList: [],
      noInTablReportList: [],
      reportKey: true,
      page: 1,
      reqParmas: {
        matchArr: [],
        page: this.page - 1,
        limit: 20,
        sortArr: [{ fieldName: 'createTime', direction: 'DESC' }]
      }
    }
  },
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    refushTable() {
      this.getData()
    },
    searchReq() {
      if (this.searchKeyword || this.searchKeyword !== '') {
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['number', 'customer', 'customerPosition', 'dataName', 'contactPerson'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize
      getSpecPositionList(this.reqParmas).then(res => {
        this.specPositionList = res.data.content.itemArr
        this.reportKey = !this.reportKey
        this.pageTotal = res.data.content.total
      })
    },
    handleReturnSelection() {
      this.$emit('chagneRelation', {
        select: this.selectRowTempList
      })
    },
    selectAllEvent(selection) {
      var reportIdArr = selection.map(obj => obj.id)
      if (selection.length === 0) {
        //移除
        this.selectRowTempList = this.selectRowTempList.filter(obj => !reportIdArr.includes(obj.id))
      } else {
        //增加
        var tempReportIdArr = this.selectRowTempList.map(obj => obj.id)
        selection.forEach(row => {
          if (!tempReportIdArr.includes(row.id)) {
            this.selectRowTempList.push(row)
          }
        })
      }
    },
    selectEvent(select, row) {
      var selectedIdArr = select.map(obj => obj.id)
      if (selectedIdArr.includes(row.id)) {
        //选中
        if (this.selectRowTempList) {
          var reportIdArr = this.selectRowTempList.map(obj => obj.id)
          if (!reportIdArr.includes(row.id)) {
            this.selectRowTempList.push(row)
          }
        } else {
          this.selectRowTempList = []
          this.selectRowTempList.push(row)
        }
      } else {
        //移除
        this.selectRowTempList = this.selectRowTempList.filter(obj => obj.id !== row.id)
      }
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.page = 1
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-report-view) {
  height: 100%;
  padding: 0 12px;
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
